import { http } from "@/api/client";
import type { ApiItemResponse, ApiListResponse } from "@/api/types";
import type { Game } from "@/types/domain";

export interface CreateGameBody {
  name?: string;
  name_zh?: string;
  name_en?: string;
  code?: string;
  category?: string;
  desc?: string;
  status?: string;
  icon?: string;
  color?: string;
}

export interface CreateGameResult {
  game: Game;
  secret: string;
}

export const gamesApi = {
  list: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiListResponse<Game>>("/api/games", query),
  get: (id: string) => http.get<ApiItemResponse<Game>>(`/api/games/${id}`),
  create: (body: CreateGameBody) => http.post<ApiItemResponse<CreateGameResult>>("/api/games", body),
  update: (id: string, body: Partial<Game>) => http.patch<ApiItemResponse<Game>>(`/api/games/${id}`, body),
  remove: (id: string) => http.delete<ApiItemResponse<Game>>(`/api/games/${id}`),
  credential: (id: string) =>
    http.get<ApiItemResponse<{ gameId: string; gameSecret: string; secret?: string }>>(`/api/games/${id}/credential`),
  rotateSecret: (id: string) =>
    http.post<ApiItemResponse<{ gameId: string; gameSecret: string }>>(`/api/games/${id}/credential/rotate`),
  listMembers: (id: string) => http.get<ApiListResponse<unknown>>(`/api/games/${id}/members`),
  addMember: (id: string, body: unknown) => http.post<ApiItemResponse<unknown>>(`/api/games/${id}/members`, body),
  listApiKeys: (id: string) => http.get<ApiListResponse<unknown>>(`/api/games/${id}/api-keys`),
  createApiKey: (id: string, body: unknown) => http.post<ApiItemResponse<unknown>>(`/api/games/${id}/api-keys`, body),
};
